import {gql} from "@apollo/client";
import {useEffect} from "react";
import {DeepPartial, UnpackNestedValue, UseFormReturn} from "react-hook-form";
import {useLazyQuery$} from "graphqlsupport";
import {NoContactInput} from "../../domain";

export type LatestNoContactData = {
    guid: string;
    authorizationGuid: string;
} & NoContactInput;

const AUTHORIZATION_LATEST_OFFERED_HOURS = gql`
query noContactByAuth($authorizationGuid: UUID) {
    noContactByAuth(authorizationGuid: $authorizationGuid) {
        guid
        authorizationGuid
        initialDateOfContactAttempt
        dateContactResumed
        dateServiceExpectedToResumed
        lastContactAttemptDate
        numberOfContactAttempts
        initialTypeOfContact
        typeOfContact
        providerWasAbleToContactClient
        comments
    }
}
`;

function useLatestNoContactInput$(authorizationGuid: string) {
    const {execute, data, isRunning$, error} = useLazyQuery$<{
        authorizationGuid: string
    }, {
        noContactByAuth: LatestNoContactData
    }>(AUTHORIZATION_LATEST_OFFERED_HOURS, {
        authorizationGuid,
    });

    return {
        execute,
        data,
        isRunning$,
        error
    };
}


export function useLatestNoContactInput(showModal: boolean, methods: UseFormReturn<NoContactInput>, authorizationGuid: string) {
    const {execute, data, isRunning$, error,} = useLatestNoContactInput$(authorizationGuid);
    useEffect(() => {
        if (showModal && authorizationGuid != null) {
            execute({
                authorizationGuid,
            });
        }
    }, [authorizationGuid, showModal, execute]);
    useEffect(() => {
        if (data?.noContactByAuth != null) {
            methods.reset({
                ...methods.getValues(),

                ...(data.noContactByAuth as UnpackNestedValue<DeepPartial<NoContactInput>>),
            });
        }
    }, [data, methods]);
    return {
        isRunning$,
        error,
    };
}

